<!--
    描述：合同
    日期：2022/7/26
    创建人：李家宝
-->
<template>
  <div>
    <div>
      <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
      <template v-else>
        <p>当前项目合同：<span style="color: #0000FF">{{tableData.length  }}</span></p>
        <el-table
          class="mt20"
          :data="tableData"
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column
            prop="contractCode"
            label="合同编号"
            align="center"
            show-overflow-tooltip
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="contractName"
            label="合同名称"
            show-overflow-tooltip
            width="270"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="合同创建时间"
            prop="createDateStr"
            show-overflow-tooltip
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="签订对象"
            show-overflow-tooltip
            prop="bidderAddress"
            align="center"
            min-width="170"
          >
            <template slot-scope="scope">
              <div>甲方：{{ scope.row.partyAName }}</div>
              <div>乙方：{{ scope.row.partyBName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="contractStatus"
            width="150"
            align="center"
            label="状态"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            width="170"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="viewContract(scope.row)"
                >查看合同</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <!--弹窗-->
      <el-dialog
        :visible.sync="dialogShow"
        width="60%"
        center
        :title="currentRowData.contractName"
        :close-on-click-modal="false"
        @close="closeDialog"
      >
        <div class="dialog-box">
          <iframe
            width="100%"
            :src="url"
            frameborder="0"
            style="width: 100%; height: 100%"
          ></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getContractInfo } from "../../../../api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  name: "contract",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: [], // 表格数据
      dialogShow: false, // 审核弹窗的显隐
      currentRowData: {}, // 当前行数据
      url: "" // 合同地址
    };
  },
  methods: {
    // 获取合同
    getContractInfo() {
      getContractInfo({
        id: this.rowData.id
      }).then(res => {
        if (res.operationCode == 1) {
          if (res.data.length != 0) {
            this.tableData = res.data.filter(i => {
              return i.fullFilePath != "";
            });
          }
        }
      });
    },

    // 查看合同
    viewContract(currentRowData) {
      this.currentRowData = currentRowData;
      this.dialogShow = true;
      let uploadUrl = "";
      // 本地环境代理后无法直接获取路径
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        // uploadUrl = process.env.VUE_APP_UPLOAD_URL;
        uploadUrl = "https://www.nenggongshe.com/file/";
      }
      this.url = this.$previewUrl + uploadUrl + currentRowData.fullFilePath;
    },

    // close 审查弹框
    closeDialog() {
      this.dialogShow = false;
    }
  },

  created() {
    this.getContractInfo();
  }
};
</script>

<style scoped>
.dialog-box {
  height: 500px;
}
</style>
